// =====================================================================
// Tenant detection — frontend only, based on subdomain.
// =====================================================================
// Rules:
//   localhost                  → no tenant   (landing)
//   127.0.0.1                  → no tenant   (landing)
//   test.localhost             → tenant = "test"
//   <apex>.com                 → no tenant   (landing)
//   <tenant>.<apex>.com        → tenant = "<tenant>"
//
// We treat anything that has more than 2 dot-separated segments as a
// tenant subdomain, plus the special-case `*.localhost` for local dev.
// "www" is treated as the apex (no tenant).
// =====================================================================

const APEX_HOSTS = new Set(['localhost', '127.0.0.1']);

/**
 * Returns the current tenant slug, or null when on the apex/landing host.
 * @returns {string | null}
 */
export function getTenantSlug() {
  if (typeof window === 'undefined') return null;
  const host = window.location.hostname;
  if (!host) return null;
  if (APEX_HOSTS.has(host)) return null;

  const parts = host.split('.');

  // *.localhost dev pattern: tenant.localhost → tenant
  if (host.endsWith('.localhost')) {
    if (parts.length >= 2 && parts[0] !== 'www') return parts[0];
    return null;
  }

  // Treat 2-part hosts (brand.com) as apex.
  if (parts.length <= 2) return null;

  // 3+ parts: first segment is the tenant unless it's "www".
  const first = parts[0];
  if (!first || first === 'www') return null;
  return first;
}

/** True when the current host should render the public landing page only. */
export function isLandingHost() {
  return getTenantSlug() === null;
}
